import {css} from 'styled-components'

export const anchors = css`
    a:not([class]) {
        &,
        &:focus,
        &:visited {
            background: transparent;
            border-color: currentColor;
            text-decoration-thickness: 1px;
            text-underline-offset: 0.2em;
        }

        & {
            color: ${(props) => props.theme.colors.link.default};
        }

        &:visited {
            color: ${(props) => props.theme.colors.link.visited};
        }

        &:hover:not(:focus) {
            background-color: ${(props) => props.theme.colors.hoverIndicator};
            color: ${(props) => props.theme.colors.link.hover};
        }

        &:focus {
            background-color: ${(props) => props.theme.colors.focus.main};
            color: ${(props) => props.theme.colors.content.primary};
        }
    }
`
